let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("boM6T")).then(() => parcelRequire('1oEhO'));